import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { Box, Typography, Card, CardContent, Stack, Button } from "@mui/material";
import { Login, Dashboard as DashboardIcon } from "@mui/icons-material";
import { Dashboard } from "../components";
import { FloatingActionButton } from "../../common/components";

function Home() {
  return (
    <>
      <AuthenticatedTemplate>
        <Dashboard />
        
        {/* Floating Action Button for quick ticket creation */}
        <FloatingActionButton 
          label="Create Ticket"
          navigateTo="/tickets/create"
          ariaLabel="Create new ticket"
        />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Box
          sx={{
            // Subtract the fixed NavBar height (75px) and PageLayout's top/bottom
            // padding (16px each) so this box fills the remaining viewport instead
            // of adding its own 100vh and pushing the card below true center.
            minHeight: 'calc(100vh - 107px)',
            backgroundColor: '#F4F6F9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 3
          }}
        >
          <Card sx={{ maxWidth: 500, width: '100%', textAlign: 'center' }}>
            <CardContent sx={{ p: 4 }}>
              <Box mb={3}>
                <DashboardIcon sx={{ fontSize: '4rem', color: '#3b82f6', mb: 2 }} />
                <Typography variant="h4" fontWeight={600} color="#1e293b" gutterBottom>
                  Welcome to Trackly
                </Typography>
                <Typography variant="h6" color="#64748b" gutterBottom>
                  Help Desk Management System
                </Typography>
              </Box>
              
              <Typography variant="body1" color="#64748b" sx={{ mb: 3 }}>
                Please sign in to access your dashboard, create tickets, and manage support requests.
              </Typography>
              
              <Stack spacing={2}>
                <Typography variant="body2" color="#64748b">
                  After signing in, you'll be able to:
                </Typography>
                <Box component="ul" sx={{ textAlign: 'left', color: '#64748b', pl: 2 }}>
                  <li>Create and track support tickets</li>
                  <li>View tickets assigned to you</li>
                  <li>Monitor ticket status and progress</li>
                  <li>Manage teams and assignments</li>
                  <li>Access comprehensive reporting</li>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Box>
      </UnauthenticatedTemplate>
    </>
  );
}

export default Home;
